/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_Discard_DraftInputs */



/**
* | output |
* | --- |
* | "Discard draft" |
*
* @param {Project_Instructions_Discard_DraftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_discard_draft = /** @type {((inputs?: Project_Instructions_Discard_DraftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_Discard_DraftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwurf verwerfen")
	return /** @type {LocalizedString} */ ("Discard draft")
});